export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';

export const DEFAULT_DATE_TIME_FORMAT = 'DD/MM/YYYY hh:mm';

export const DEFAULT_SEPARATOR = ' - ';

export const SUPPORTED_SEPARATORS = [
  ' - ',
  ' | ',
  ' * ',
  ' & ',
  ', ',
  ' # ',
  ' + ',
  '!',
  ' > ',
  ' < ',
  ' ~ ',
  ' = ',
  '_',
  ': ',
  '; '
];

export const DEFAULT_LOCALE = 'en-US';

export const navOpenWidth = 210;
